export const cacheKey = "/engagement/webhook_templates/:id" as const;
